import { ChevronLeft, Loader2, MessageCircle } from 'lucide-react';
import { Suspense, lazy, useState } from 'react';

// Lazy load Element Web for better performance
const ElementWebClient = lazy(() => 
  import('../../external/element-web/src/HexaTalkApp').catch(() => ({
    default: () => (
      <div className="flex flex-col items-center justify-center h-full text-white/60">
        <MessageCircle className="w-16 h-16 mb-4 opacity-20" />
        <p>Element Web not available</p>
        <p className="text-sm mt-2">Run: cd external/element-web && npm install</p>
      </div>
    )
  }))
);

interface MessagesAppProps {
  onBack: () => void;
}

export function MessagesApp({ onBack }: MessagesAppProps) {
  const [useElementWeb, setUseElementWeb] = useState(true);

  // Render Element Web if enabled
  if (useElementWeb) {
    return (
      <div className="h-full relative bg-macos-gray-100 dark:bg-macos-gray-950">
        <Suspense fallback={
          <div className="flex flex-col items-center justify-center h-full">
            <Loader2 className="w-8 h-8 text-macos-blue animate-spin mb-4" />
            <p className="text-macos-gray-600 dark:text-macos-gray-400">Loading Element Web...</p>
          </div>
        }>
          <ElementWebClient onBackToDesk={onBack} />
        </Suspense>
        
        {/* Toggle to simple UI */}
        <button
          onClick={() => setUseElementWeb(false)}
          className="absolute top-4 right-20 z-50 px-3 py-1.5 text-xs glass-macos bg-white/60 dark:bg-macos-gray-900/60 hover:bg-white/80 dark:hover:bg-macos-gray-900/80 rounded-macos transition-colors border border-macos-gray-200 dark:border-macos-gray-800"
        >
          Simple UI
        </button>
      </div>
    );
  }

  // Simple UI fallback
  return (
    <div className="min-h-screen bg-macos-gray-100 dark:bg-macos-gray-950 text-macos-gray-900 dark:text-white">
      <div className="glass-macos bg-white/80 dark:bg-macos-gray-900/80 border-b divider-macos sticky top-0 z-50">
        <div className="px-4 sm:px-6">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center gap-3">
              <button
                onClick={onBack}
                className="w-9 h-9 rounded-full hover:bg-macos-gray-200 dark:hover:bg-macos-gray-800 flex items-center justify-center transition-colors"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <h1 className="text-lg font-medium">Messages</h1>
            </div>
            <button
              onClick={() => setUseElementWeb(true)}
              className="btn-macos"
            >
              Use Element Web
            </button>
          </div>
        </div>
      </div>
      <div className="p-6">
        <p className="text-macos-gray-600 dark:text-macos-gray-400 mb-4">Secure messaging - Matrix protocol enabled</p>
        <p className="text-sm text-macos-gray-500 dark:text-macos-gray-500">
          Click "Use Element Web" above for full messaging features including E2E encryption, group chats, calls, and more.
        </p>
      </div>
    </div>
  );
}
